import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translation_en from './en.json';
import translation_zh from './zh.json';
import {isCustomerUser} from "../utils/user";

const resources = {
    en: {
        translation: translation_en,
    },
    zh: {
        translation: translation_zh,
    },
};

// 只在URL参数明确指定语言且localStorage中没有语言设置时才设置
if(window.location.search.endsWith("en") && !localStorage.getItem("lang")){
   localStorage.setItem("lang", "en")
}else if(!window.location.search.endsWith("en") && !localStorage.getItem("lang")){
   localStorage.setItem("lang", "zh");
}

let cacheLang = localStorage.getItem("lang");

i18n.use(initReactI18next).init({
    resources,
    lng: cacheLang?.length > 0 && isCustomerUser() ? cacheLang : "zh",
    interpolation: {
       escapeValue: false,
    },
}).then();

export default i18n;
